import React from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { adminGet } from "../../lib/adminApi";
import { OnlineBanner } from "../../components/aanmetingen/OnlineBanner";
import { ErrorBanner, OvergeslagenBanner } from "../../components/admin/AdminUI";
import { AanmetingWizard } from "../../components/aanmetingen/AanmetingWizard";

export default function WizardPage() {
  const { aanmeetdag_id, werknemer_id } = useParams();
  const uQ = useQuery({
    queryKey: ["uitvoeringen-dag", aanmeetdag_id],
    queryFn: () => adminGet(`/api/admin/aanmeetdagen/${aanmeetdag_id}/uitvoeringen`),
  });
  const werkQ = useQuery({
    queryKey: ["werknemer", werknemer_id],
    queryFn: () => adminGet(`/api/admin/werknemers/${werknemer_id}`),
  });
  const items = uQ.data?.items || uQ.data || [];
  const uitvoering = items.find((u) => u.werknemer_id === werknemer_id);

  return (
    <div className="min-h-screen bg-slate-50">
      <OnlineBanner />
      <div className="mx-auto max-w-5xl px-4 py-4">
        <Link to={`/aanmetingen/dag/${aanmeetdag_id}`} data-testid="back-to-werknemers"
          className="mb-3 inline-block text-sm text-blue-600 hover:underline">← Terug naar werknemers</Link>
        <ErrorBanner error={uQ.error || werkQ.error} />
        {/* Deze pagina zoekt de aanmeting van één werknemer op in de dagplanning. Is die
            overgeslagen, dan lijkt het alsof hij niet is ingepland. */}
        <OvergeslagenBanner
          aantal={uQ.data?.overgeslagen} enkelvoud="aanmeting" meervoud="aanmetingen"
          testid="wizard-uitvoeringen-overgeslagen"
        />
        {!uitvoering || !werkQ.data ? (
          <div data-testid="wizard-loading" className="rounded-md border border-slate-200 bg-white p-6 text-sm text-slate-500">
            Laden…
          </div>
        ) : (
          <AanmetingWizard
            uitvoering={uitvoering}
            werknemer={werkQ.data}
            aanmeetdagId={aanmeetdag_id}
          />
        )}
      </div>
    </div>
  );
}
